import { render, staticRenderFns } from "./GuestBoxExt.vue?vue&type=template&id=0244f2ad&scoped=true&"
import script from "./GuestBoxExt.vue?vue&type=script&lang=js&"
export * from "./GuestBoxExt.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxExt.vue?vue&type=style&index=0&id=0244f2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244f2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0244f2ad')) {
      api.createRecord('0244f2ad', component.options)
    } else {
      api.reload('0244f2ad', component.options)
    }
    module.hot.accept("./GuestBoxExt.vue?vue&type=template&id=0244f2ad&scoped=true&", function () {
      api.rerender('0244f2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ef95sz9CSqZp/JS/comp/GuestBoxExt.vue"
export default component.exports